import React, { useState, useContext } from 'react'
import { useTranslation, Trans } from 'react-i18next'

import { CircleSpinner } from 'shared'

import { SDDOverview } from './SDDOverview'
import { SddMultistepValues } from './SDDMultistep/SDDMultistepValues'

import './sepaDirectDebit.scss'
import SspContext from 'selfServicePortal/contexts/SspContext'
import { IBankInfoProps } from 'selfServicePortal/interfaces/i-api-sdd'
import sddService from 'selfServicePortal/services/CreditCardServices/sddService'

const SepaDirectDebit = () => {
	const { t } = useTranslation()
	const { customerData, isSddEligible, loading } = useContext(SspContext)

	const [load, setLoad] = useState<boolean>(false)
	const [showMultistep, setShowMultistep] = useState<boolean>(false)
	const [bankInfo, setBankInfo] = useState<IBankInfoProps[]>()

	async function getSddIbans(partyId: string) {
		try {
			sddService.getSddIbans(partyId).then((response) => {
				if (response.status === 200) {
					setBankInfo(response.data as IBankInfoProps[])
				} else {
					console.warn(response.data)
				}
			})
		} catch (err) {
			console.warn(err)
			throw err
		}
	}

	async function getMultistep() {
		setLoad(true)
		await getSddIbans(customerData?.customerId!).then(() => {
			setShowMultistep(true)
		})
		setTimeout(() => {
			setLoad(false)
		}, 1000)
	}

	return (
		<div className="fade-in sepa-direct-debit container">
			<div className="fixed-width my-5">
				{loading ? (
					<CircleSpinner />
				) : (
					<>
						{!isSddEligible?.eligible ? (
							<div className="sdd-enrollment-container">
								<div className="sdd-enrollment-start">
									<div className="heading">
										<h5 className="title">
											{t('SDDTitle')}
										</h5>
										<div className="description">
											{t('SDDNotEligible')}
										</div>
									</div>
								</div>
							</div>
						) : (
							<>
								{isSddEligible?.activeMandate ? (
									<SDDOverview />
								) : (
									<>
										{load ? (
											<CircleSpinner />
										) : (
											<div className="sdd-enrollment-container">
												{showMultistep ? (
													<SddMultistepValues
														bankInfoList={bankInfo!}
													/>
												) : (
													<div className="sdd-enrollment-start">
														<div className="heading">
															<h5 className="title">
																{t('SDDTitle')}
															</h5>
															<div className="description">
																<Trans
																	t={t}
																	i18nKey="SDDDescription">
																	Minimum
																	amounts due
																	can now be
																	collected
																	easily and
																	always on
																	time. In
																	order to be
																	able to pay
																	your bill
																	immediately
																	by direct
																	debit, give
																	us a direct
																	debit
																	mandate in
																	just a few
																	steps.
																	<br />
																	<br />
																	You can
																	cancel SDD
																	at any time
																	and set it
																	up again.
																</Trans>
															</div>
														</div>
														<button
															className="btn btn-primary sdd-enrollment-start-btn"
															type="button"
															onClick={() =>
																getMultistep()
															}>
															{t(
																'GetSDDButtonText'
															)}
														</button>
													</div>
												)}
											</div>
										)}
									</>
								)}
							</>
						)}
					</>
				)}
			</div>
		</div>
	)
}

export default SepaDirectDebit
